import {GRADOS, LOADING_GRADOS, SELECTED_GRADO} from '../types';
import {AppEnv} from '../../../components/env';
import axios from 'axios';
import Functions from '../../../components/Global/Functions';

const apiUrl = AppEnv.api;

export function setLoading(data) {
    return {
        type: LOADING_GRADOS,
        payload: data
    };
}

export function createGrado(token, country, nivel, tipoNivel, ciclo, fd) {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.post(apiUrl + 'grados/create', fd, {
                method: 'post', headers: {
                    Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token
                }
            }
        ).then((response) => {
            Functions.alertSuccess();
            dispatch(fetchGrados(token, country, nivel, tipoNivel, ciclo));
        }).catch(error => {
            Functions.alertFail();
            dispatch(fetchGrados(token, country, nivel, tipoNivel, ciclo));
        });
    };
}

export function fetchGrados(token, country, nivel, tipoNivel, ciclo) {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.get(apiUrl + 'grados/get/' + country + '/' + nivel + '/' + tipoNivel + '/' + ciclo, {
                method: 'get', headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: 'Bearer ' + token
                }
            }
        ).then((response) => {
            dispatch(fetchGradosSuccess(response.data));
        }).catch(error => {
            dispatch(fetchGradosFailed());
        });
    };
}

export function updateGrado(token, country, nivel, tipoNivel, ciclo, fd, id) {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.post(apiUrl + 'grados/update/' + id, fd, {
                method: 'post', headers: {
                    Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token
                }
            }
        ).then((response) => {
            Functions.alertSuccess();
            dispatch(fetchGrados(token, country, nivel, tipoNivel, ciclo));
        }).catch(error => {
            Functions.alertFail();
            dispatch(fetchGrados(token, country, nivel, tipoNivel, ciclo));
        });
    };
}

export function deleteGrado(token, country, nivel, tipoNivel, ciclo, id) {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.get(apiUrl + 'grados/delete/' + id, {
                method: 'get', headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: 'Bearer ' + token
                }
            }
        ).then((response) => {
            Functions.alertSuccess();
            dispatch(fetchGrados(token, country, nivel, tipoNivel, ciclo));
        }).catch(error => {
            Functions.alertFail();
            dispatch(fetchGrados(token, country, nivel, tipoNivel, ciclo));
        });
    };
}

export function fetchGradosSuccess(response) {
    return {
        type: GRADOS,
        payload: response
    };
}

export function fetchGradosFailed() {
    Functions.alertFail();
    return {
        type: GRADOS,
        payload: []
    };
}

export function setGrado(Grado) {
    return {
        type: SELECTED_GRADO,
        payload: Grado
    };
}
